"use client";

import { Avatar } from "@nextui-org/avatar";
import { Tooltip } from "@nextui-org/react";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import ExpandableText from "@/app/components/ExpandibleText";
import { AssociateProfiles } from "@/app/author/(components)/AssociateButton";
import CopernicusBadge from "@/app/author/(components)/CopernicusBadge";

export function AuthorHeader({ info, isVerified, authorId, isCopernicus }) {
  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="mb-5">
        <Avatar
          src={info.img || "/autoricon.png"}
          className="h-40 w-40 text-large"
          name={`Foto de ${info.label}`}
        />
      </div>
      <h1 className="flex max-w-4xl items-center justify-center gap-2 text-balance text-3xl font-semibold sm:text-4xl md:text-5xl">
        <span className="text-blue-800">{info.label}</span>
        {isVerified && (
          <Tooltip content="Perfil verificado en REDI" placement="top" showArrow>
            <span className="inline-flex shrink-0">
              <RiVerifiedBadgeFill
                className="text-3xl text-cyan-400"
                aria-label="Perfil verificado en REDI"
                role="img"
              />
            </span>
          </Tooltip>
        )}
        {isCopernicus && (
          <Tooltip
            content="Colaborador en el programa Copernicus"
            placement="top"
            showArrow
          >
            <span className="inline-flex shrink-0">
              <CopernicusBadge size={28} compact />
            </span>
          </Tooltip>
        )}
      </h1>

      {info.bio && (
        <div className="w-full max-w-3xl">
          <ExpandableText text={info.bio} />
        </div>
      )}

      <AssociateProfiles
        label={info.label}
        authorId={authorId}
        isVerified={isVerified}
      />
    </div>
  );
}
